import Axios from "axios";
import api from "../../api";
import adapter, { subAdapter } from "./adapter";
import {
  blobToFile,
  generateRequestHeaders,
  errorHandler,
} from "../../utils";
import singleService from '../program/service';
import apiService from "../api/service";

const subService = {
  general: {
    updateMany(name, ids, bulk){
      return new Promise((resolve, reject) => {
        if(ids && ids.length > 0){
          const total = ids.length
          let count = 0
          let success = 0
          let failed = 0

          function check(){
            if(count === total){
              // updating process is done
              console.log(`
                ${count}/${total} ${name} processed.\n
                ${success} succeeded.\n
                ${failed} failed.
              `)

              resolve()
            }
          }

          for (let index = 0; index < ids.length; index++) {
            const id = ids[index];
            const data = bulk.find(d => d.id === id)
            if(data){
              /* eslint-disable */
              service[name].updateOne(data)
                .then(res => {
                  success++
                })
                .catch(err => {
                  failed++
                })
                .then(() => {
                  count++
                  check()
                })
              /* eslint-enable */
            } else {
              failed++
              check()
            }
          }
        } else {
          reject('empty data.')
        }
      })
    },
    deleteMany(name, ids){
      return new Promise((resolve, reject) => {
        if(ids && ids.length > 0){
          const total = ids.length
          let count = 0
          let success = 0
          let failed = 0

          function check(){
            if(count === total){
              // delete process is done
              console.log(`
                ${count}/${total} ${name} processed.\n
                ${success} succeeded.\n
                ${failed} failed.
              `)

              resolve()
            }
          }

          for (let index = 0; index < ids.length; index++) {
            const id = ids[index];
            /* eslint-disable */
            service[name].deleteOne(id)
              .then(res => {
                success++
              })
              .catch(err => {
                failed++
              })
              .then(() => {
                count++
                check()
              })
            /* eslint-enable */
          }
        } else {
          reject('empty data.')
        }
      })
    }
  },
  journey: {
    updateImage(id, blob, meta){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }

        if(id){
          const url = `${api.base}${api.programs_journey}${id}/`
          blobToFile(blob, meta.name, meta.type).then((file) => {
            const formData = new FormData()
            formData.append('imgThumbnailJourney', file)
            Axios.put(url, formData, config)
              .then(res => resolve(res))
              .catch(err => reject(err))
          })
        } else {
          reject('id not provided')
        }
      })
    },
    updateOne(data){
      console.log({data})
      return new Promise((resolve, reject) => {
        /*
        total process 2,
        1. basic update
        2. image update
        */
        const total = 2
        let count = 0

        function check(){
          count++
          if(count === total){
            resolve()
          }
        }

        if(data){
          const config = {
            headers: generateRequestHeaders()
          }

          const requestBody = subAdapter.journey.formToRequestBody(data)

          if(data.id){
            const url = `${api.base}${api.programs_journey}${data.id}/`

            // Basic Update
            Axios.put(url, requestBody, config)
              .finally(() => check())

            // Image Update
            const isNeedToUpdateImage = data.image.slice(0,4) === 'blob' && data._image
            if(isNeedToUpdateImage){
              const { blob, name, type } = data._image
              blobToFile(blob, name, type).then((file) => {
                const formData = new FormData()
                formData.append('imgThumbnailJourney', file)
                Axios.put(url, formData, config)
                  .finally(() => check())
              })
            } else {
              check()
            }
          } else {
            reject('id not provided')
          }
        } else {
          reject('data not provided')
        }
      })
    },
    updateMany(ids, bulk){
      return service.general.updateMany('journey', ids, bulk)
    },
    deleteOne(id){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_journey}${id}/`, config)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('journey', ids)
    }
  },
  milestone: {
    updateFile(id, blob, meta){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }

        if(id){
          const url = `${api.base}${api.programs_milestone}${id}/`
          blobToFile(blob, meta.name, meta.type).then((file) => {
            const formData = new FormData()
            formData.append('binFaseFile', file)
            Axios.put(url, formData, config)
              .then(res => resolve(res))
              .catch(err => reject(err))
          })
        } else {
          reject('id not provided')
        }
      })
    },
    updateOne(data){
      return new Promise((resolve, reject) => {
        const total = 2
        let count = 0

        function check(){
          count++
          if(count === total){
            resolve()
          }
        }

        if(data){
          const config = {
            headers: generateRequestHeaders()
          }

          const requestBody = subAdapter.milestone.formToRequestBody(data)

          if(data.id){
            const url = `${api.base}${api.programs_milestone}${data.id}/`

            // Basic Update
            Axios.put(url, requestBody, config)
              .finally(() => check())

            // Image Update
            const firstFile = data.files[0]
            const fileUrl = firstFile?.file

            const isNeedToUpdateFile = (fileUrl && fileUrl.slice(0,4) === 'blob') || false
            if(isNeedToUpdateFile){
              blobToFile(fileUrl, firstFile.name, firstFile.type).then((file) => {
                const formData = new FormData()
                formData.append('binFaseFile', file)
                Axios.put(url, formData, config)
                  .finally(() => check())
              })
            } else {
              check()
            }
          } else {
            reject('id not provided')
          }
        } else {
          reject('data not provided')
        }
      })
    },
    updateMany(ids, bulk){
      return service.general.updateMany('milestone', ids, bulk)
    },
    deleteOne(id){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_milestone}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('milestone', ids)
    }
  },
  partner: {
    deleteOne(pkId){
      const id = pkId
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_partner_internal}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('partner', ids)
    }
  },
  partner_external: {
    updateImage(id, blob, meta){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }

        if(id){
          const url = `${api.base}${api.programs_partner_external}${id}/`
          blobToFile(blob, meta.name, meta.type).then((file) => {
            const formData = new FormData()
            formData.append('imgLogoPartner', file)
            Axios.put(url, formData, config)
              .then(res => resolve(res))
              .catch(err => reject(err))
          })
        } else {
          reject('id not provided')
        }
      })
    },
    updateOne: async (data) => {
      console.log('updateOne partner_external data:', data)

      const { id, new_image } = data
      const requestBody = subAdapter.partner.external.formToRequestBody(data)
      console.log(requestBody)

      let newImage
      let formData = new FormData()

      if(new_image && new_image.blob){
        newImage = await blobToFile(new_image.blob, new_image.name, new_image.type)
        formData.append('imgLogoPartner', newImage)
      }

      const requestBodyFile = newImage ? formData : false

      const promise1 = apiService.update('programs_partner_external', id, requestBody)
      const promise2 = apiService.update('programs_partner_external', id, requestBodyFile)

      return Promise.all([promise1, promise2])
        .then((res) => {
          console.log(res)
          return (res)
        })
        .catch(err => {
          console.log(err)
          return (err)
        })
    },
    updateMany(ids, bulk){
      return service.general.updateMany('partner_external', ids, bulk)
    },
    deleteOne(pkId){
      const id = pkId
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_partner_external}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('partner_external', ids)
    }
  },
  location: {
    updateOne(id, requestBody){
      return new Promise((resolve, reject) => {
        if(id){
          apiService.update('programs_location', id, requestBody)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteOne(pkId){
      const id = pkId
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_location}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('location', ids)
    }
  },
  gallery: {
    updateOne(data){
      console.log(data)
    },
    updateMany(ids, bulk){
      return service.general.updateMany('gallery', ids, bulk)
    },
    deleteOne(id){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_gallery}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => reject(err))
        } else {
          reject('id not provided')
        }
      })
    },
    deleteMany(ids){
      return service.general.deleteMany('gallery', ids)
    }
  },
  file: {
    deleteOne(id){
      return new Promise((resolve, reject) => {
        const config = {
          headers: generateRequestHeaders()
        }
        if(id){
          Axios.delete(`${api.base}${api.programs_file}${id}/`, config)
            .then(res => resolve(res))
            .catch(err => {
              const msg = errorHandler(err)
              reject(msg)
            })
        } else {
          reject('id not provided')
        }
      })
    },
  }
}

const service = {
  ...subService,

  /**
   * CREATE - BASIC
   * @param {Object} data
   */
  async createBasicProgram(data){
    return new Promise(function(resolve, reject){
      const config = {headers: generateRequestHeaders()}
      let requestBody = adapter.formToBasicRequestBody(data)
      console.log('requestBody', requestBody)

      return Axios.post(api.base+api.programs, requestBody, config)
        .then(res => {
          console.log(res)

          // Handle images
          const isNeedToHandleImage = data.image || data.thumbnail

          if(isNeedToHandleImage && res && res.data && res.data.programId){
            const { programId: id } = res.data
            if(id){
              service.createProgramImages(id, data)
                .catch(err => {
                  console.error('failed to update image after creating program; function error.', err)
                })
                .finally(resolve(res))
            } else {
              console.error('failed to update image after creating program; id is not provided.')
              resolve(res)
            }
          } else {
            resolve(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * CREATE
   * @param {Object} data
   */
  async createProgram(data){
    return new Promise(function(resolve, reject){
      // maxResolveCount = how many request needed after create program
      const maxResolveCount = 3
      let resolveCount = 0
      function checkResolve(data){
        resolveCount++
        if(resolveCount === maxResolveCount){
          resolve(data)
        }
      }

      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      /* Axios */
      Axios.post(api.base+api.programs, requestBody, config)
      .then(res => {
        if(res.data){
          /**
           * Images
           */
          const isNeedToHandleImage = (
            data.image
            || data.thumbnail
          )
          if(isNeedToHandleImage){
            const id = res.data.programId
            if(id){
              service.createProgramImages(id, data)
              .then((res1) => console.log(res1))
              .catch(err => console.log(err))
              .then(() => {
                checkResolve(res.data)
              })
            } else {
              checkResolve(res.data)
            }
          } else {
            checkResolve(res.data)
          }

          /**
           * Gallery
           */
          const isNeedToHandleGallery = ( data.gallery.length > 0 )
          if(isNeedToHandleGallery){
            const id = res.data.programId
            if(id){
              service.createProgramGallery(id, data)
              .then((res1) => console.log(res1))
              .catch(err => console.log(err))
              .then(() => {
                checkResolve(res.data)
              })
            } else {
              checkResolve(res.data)
            }
          } else {
            checkResolve(res.data)
          }

          /* Statistic Update */
          const id = res.data.programId
          singleService.getData(id).then((res) => {
            const pkActivityResultId = res.pkActivityResultId
            service.updateStatistic(pkActivityResultId, requestBody.activityResult)
          }).finally(() => {
            checkResolve(res.data)
          })
        }else{
          resolve(res)
        }
      })
      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
    })
  },

  async createProgramImages(id, data){
    return new Promise(function(resolve, reject){
      // Handle images
      const formData = new FormData()

      let maxCount = 2
      let count = 0

      function useService(){
        count++
        if(count === maxCount){
          service.updateImage(id, formData)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            const message = errorHandler(err)
            reject(message)
          })
        }
      }

      if(data.thumbnail && data.thumbnail !== null){
        const { blob, name, type } = data._thumbnail

        blobToFile(blob, name, type)
          .then((file) => {
            formData.append('imgThumbnail', file)
            useService()
          })
          .catch(err => console.log(err))
      }
      if(data.image && data.image !== null){
        const { blob, name, type } = data._image

        blobToFile(blob, name, type)
          .then((file) => {
            formData.append('imgMainImage', file)
            useService()
          })
          .catch(err => console.log(err))
      }
    })
  },

  async createProgramGallery(id, data){
    return new Promise(function(resolve, reject){
      if(id){
        // Get program details
        singleService.getData(id)
        .then(res => {
          if(res.galleries && res.galleries.length > 0){
            for (let index = 0; index < res.galleries.length; index++) {
              const element = res.galleries[index];
              const imageId = element.pkGalleryId
              const {blob, name, type} = data.gallery_meta[index]

              blobToFile(blob, name, type)
                .then(image => {
                  const formData = new FormData()
                  formData.append('imgGambar', image)
                  service.updateGallery(imageId, formData)
                  .then(res1 => console.log(res1))
                  .catch(err1 => console.log(err1))
                  .then(() => resolve())
                })
                .catch(err => console.log(err))
            }
          } else {
            resolve()
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        })
      } else {
        console.log('id not provided', id)
      }
    })
  },

  /**
   * PUT - update program
   */
  async updateProgram({id, data}){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      /**
       * Kosongkan field gallery karena nanti ada service sendiri untuk update gallery
       */
      requestBody.galleries = []

      /**
       * [TEMPORARY] Kosongkan field partner dan location, karena ada bug duplication
       */
      // requestBody.lokasi = []
      // requestBody.partnerActivityInternal = []
      // requestBody.partnerActivityEksternal = []
      requestBody.files = []

      // Split statistics from main request body, because backend system duplicating behaviour
      const statisticsRequestBody = {...requestBody.activityResult}
      delete requestBody.activityResult

      // Split baseline-endline survey
      const surveyRequestBody = [...statisticsRequestBody.baselineEndlineSurvey]
      delete statisticsRequestBody.baselineEndlineSurvey

      // Check if new baseline-endline added
      const newSurveyData = []
      for (let index = 0; index < surveyRequestBody.length; index++) {
        const element = surveyRequestBody[index];
        if(!element.pkBaselineEndlineSurveyId){
          newSurveyData.push(element)
        }
      }
      if(newSurveyData.length > 0){
        statisticsRequestBody.baselineEndlineSurvey = newSurveyData
      }

      if(id){
        /* Basic Update */
        Axios.put(`${api.base}${api.programs}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });

        /* Statistic Update */
        const pkActivityResultId = data.pkActivityResultId
        service.updateStatistic(pkActivityResultId, statisticsRequestBody)

        /* Baseline-endline survey Update */
        for (let index = 0; index < surveyRequestBody.length; index++) {
          const element = surveyRequestBody[index];
          const { pkBaselineEndlineSurveyId: id } = element
          if(id){
            service.updateBaselineEndlineSurvey(id, element)
          }
        }
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateProgramDirect(id, data){
    // Update program without adapting requestBody data
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = data
      console.log('requestBody', requestBody)

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateImage(id, formData){
    return new Promise(function(resolve, reject){
      let requestBody = formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
        // resolve()
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateGallery(id, formData){
    return new Promise(function(resolve, reject){
      let requestBody = formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs_gallery}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
        // resolve()
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateFile(id, formData){
    return new Promise(function(resolve, reject){
      let requestBody = formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs_file}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateStatistic(id, data){
    // Update program without adapting requestBody data
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = data
      console.log('requestBody', requestBody)

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs_statistic}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateBaselineEndlineSurvey(id, data){
    // Update program without adapting requestBody data
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = data
      console.log('requestBody', requestBody)

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.programs_survey}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('baseline-endline survey id not provided.')
      }
    })
  },

  /**
   * DELETE
   */
  async deleteProgram(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.programs}${id}/`, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
